import apiRequest from "../../utils/apiRequest";

const getAllNotificationsApi = async () => {
        return await apiRequest('newLead', 'post');
};

export default getAllNotificationsApi;
